module.exports = __webpack_public_path__ + "media/images/pic/authors/monika-zachaj-dab95c2b6c7932a6930954e8243b9a34.png";